import { lazy } from 'react';
import urlPath from 'src/constants/urlPath';
import MainLayoutV2 from 'src/layouts/v2/MainLayout';
import type { RouteGroup } from './types';
import TicketLayout from 'src/layouts/v2/TicketLayout';

const Home = lazy(() => import('src/pages/v2/Home'));
const ApplicationMenu = lazy(() => import('src/pages/v2/Home/ApplicationMenu/ApplicationMenu'));
const EmployeeInfo = lazy(() => import('src/pages/v2/Home/EmployeeInfo'));

export const commonRoutes: RouteGroup = [
  {
    path: urlPath.applicationMenuDrawer.location,
    Layout: MainLayoutV2,
    Component: ApplicationMenu
  },
  {
    path: urlPath.employeeInfo.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: EmployeeInfo,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: urlPath.home.location,
    Layout: MainLayoutV2,
    Component: Home,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  }
];
